import z, { string } from 'zod';
import { fundingRequestTotalsSchema } from './fundingRequestTotalsSchema';

export const deleteFundingRequestResultSchema =
  fundingRequestTotalsSchema.merge(
    z.object({
      id: string(),
    })
  );
